// extracted by mini-css-extract-plugin
export default {"buttonPanelWrapper":"ButtonPanelStyles_buttonPanelWrapper__NdBJG","buttonPanel":"ButtonPanelStyles_buttonPanel__X6xho","jokerText":"ButtonPanelStyles_jokerText__dzqSg"};